<template>
  <section class="app-main">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"
                 :key="key">
    </router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key () {
      return this.$route.fullPath
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-main {
  width: 100%;
  height: 100%;
  flex: 1;
  margin-top: 122px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/components/AppMain.vue